'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _all = require('../../../data/all.json');

var _all2 = _interopRequireDefault(_all);

var _nimbleEmojiIndex = require('./nimble-emoji-index');

var _nimbleEmojiIndex2 = _interopRequireDefault(_nimbleEmojiIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emojiIndex = new _nimbleEmojiIndex2.default(_all2.default);
var emojis = emojiIndex.emojis;
var emoticons = emojiIndex.emoticons;


function search() {
  return emojiIndex.search.apply(emojiIndex, arguments);
}

exports.default = { search: search, emojis: emojis, emoticons: emoticons };


/*****************
 ** WEBPACK FOOTER
 ** ../~/emoji-mart/dist/utils/emoji-index/emoji-index.js
 ** module id = 1632
 ** module chunks = 3
 **/